/*
埋点
 */

/**
 * EXP特指曝光事件
 * CLK特指点击事件
 * OTHER 其他事件埋点
 * */
export const EventType = {
  Exp: 'EXP',
  Click: 'CLK',
  Other: 'OTHER'
}

/**
 * 在埋点方案中，明确的所需埋点内容有：
 1、事件主体：指“谁”触发了这个事件，分为设备ID和账号ID，上报的事件务必具备其中之一。
 设备ID：在H5中一般为QT自动生成，若H5页面嵌入在小程序中，则设备ID需要设置为小程序的设备ID。
 账号ID：客户端用户登录后账号标识，当一个用户在不同的设备进行登录时，设备ID会发生变化，但是账号ID不会发生变化。例如一个用户使用手机和pad分别登录。
 2、用户属性：针对账号ID的属性，例如账号ID为“testdemo@111”的用户，“生日”为“1999-02-13”，“会员等级”为“铂金”等。“生日”和“会员”等级就为用户属性。
 3、渠道属性：广告投放的属性，例如投放渠道、投放方式、投放内容等。
 4、全局属性：在全局设置一次后，每一个事件都会携带的属性
 5、页面浏览事件：页面加载时上报的事件（埋点方案中页面编码和事件编码相等的事件，也是标记为蓝色的事件）
 6、点击、曝光、自定义事件：客户端用户与客户端发生任意交互时上报的事件。
 **/
/* 设置用户属性 */
export function setUserInfo(data, key) {
  window.aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_user_id', data[key || 'companyId']]
  })
  window.aplus_queue.push({
    action: 'aplus.record',
    arguments: ['$$_user_profile', 'OTHER', data]
  })
}

/**
 *
 * @description 获取用户属性信息进行埋点
 * @param ponintParams Object   companyId 和 userBasicId
 *  */
export function getBurialPoint(api, params) {
  api &&
    api(params)
      .then(res => {
        if (res.code === 1) {
          setUserInfo(res.data)
        }
      })
      .catch(err => {
        console.log(err)
      })
}

/**
 * @description 发送埋点事件
 * @param eventName String   事件名
 * @param eventType String  事件类型
 * @param params String  事件属性
 * @param pageName Array 页面
 **/
export function sendTrackEvent({ eventName, pageName = eventName, eventType = EventType.Click, params }) {
  window.aplus_queue.push({
    action: 'aplus.record',
    arguments: [
      eventName,
      eventType,
      {
        ...params
      }
    ]
  })
}

/**
 *
 * @description 自动曝光的前置回调函数，用于支持定制化参数上报，如驼峰写法等（html数据属性默认只支持小写）曝光  1.9.25版本及以上支持
 * @param className String
 * /**
 * @description 配置曝光的
 * @param positionSelector String   滚动条元素class
 * @param className String  选择器的className, 建议不要项目里不要重名
 * @param eventName String 曝光的事件
 * @param props Array 获取的属性
 *
 *
 *  */

export function exposure({ positionSelector, className, eventName, props }) {
  if (positionSelector) {
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: [
        'aplus-auto-exp',
        [
          {
            positionSelector, // 你的滚动条元素class
            cssSelector: className, // 你要曝光的元素class
            logkey: eventName, // 埋点方案中对应的事件编码
            props // 自动曝光会携带item的name字段
          }
        ]
      ]
    })
  } else {
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: [
        'aplus-auto-exp',
        [
          {
            cssSelector: className, // 你要曝光的元素class
            logkey: eventName, // 埋点方案中对应的事件编码
            props // 自动曝光会携带item的name字段
          }
        ]
      ]
    })
  }
}

/**
 *
 * @description  初始化埋点
 * @param aplusData Object
 *
 */
function initQueue(aplusData) {
  window.aplus_queue = []
  for (const key in aplusData) {
    window.aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: [key, aplusData[key]]
    })
  }
  /**
   *枚举类型, 可用值及说明如下：
   "START":  开启日志发送
   "BLOCK": 阻止日志发送，可以在 BLOCK状态之前，完善发送日志前的准备工作
   * 发送Hold信号. 在 SDK整个生命周期内, _hold可设置多次，但BLOCK与START需成对出现，否则会影响日志发送
   */
  window.aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_hold', 'START']
  })
}

// 引入js
async function loadQuickTrackSDK(sdkUrl) {
  window['aplus_queue'] = window['aplus_queue'] || []
  var f = document.getElementsByTagName('script')[0]
  var j = document.createElement('script')
  j.async = true
  j.id = 'beacon-aplus'
  j.src = sdkUrl
  f.parentNode.insertBefore(j, f)
}

export default {
  install(Vue, obj, sdkUrl) {
    if (!window.aplus_queue) {
      initQueue(obj)
      loadQuickTrackSDK(sdkUrl).then(r => {
        const vm = Vue.prototype
        vm.$aplus_queue = window.aplus_queue
        vm.$track = function(name, params, eventType, pageName) {
          console.log('埋点name: ', name)
          console.log('埋点params: ', params)
          // 注册事件埋点
          sendTrackEvent({
            eventName: name,
            params,
            eventType,
            pageName
          })
        }
        vm.$exposure = exposure // 注册曝光滚动等埋点
        window.$track = vm.$track
      })
    }
  }
}
